import { render, staticRenderFns } from "./PanelSvg.vue?vue&type=template&id=39bc64de&"
import script from "./PanelSvg.vue?vue&type=script&lang=js&"
export * from "./PanelSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports